import React from "react";
import { SecondaryCompactButton } from "./secondary-button";

export interface ButtonSelectOption {
    id: string;
    label: string;
    icon?: React.ComponentType<React.ComponentProps<"svg">>;
    count?: number;
}

interface ButtonSelectProps {
    options: ButtonSelectOption[];
    selectedIds: string[];
    onToggle: (id: string) => void;
}

export const ButtonSelect: React.FC<ButtonSelectProps> = props => {
    const { options, selectedIds, onToggle } = props;
    return (
        <div className="flex flex-wrap gap-1.5 my-2">
            {options.map(option => {
                const Icon = option.icon;
                return (
                    <SecondaryCompactButton
                        key={option.id}
                        type="button"
                        selected={selectedIds.includes(option.id)}
                        onClick={() => onToggle(option.id)}>
                        <span className="inline-flex items-center gap-1">
                            {Icon ? <Icon className="w-4 h-4" /> : null}
                            {option.label}
                            {option.count != null ? (
                                <span className="inline-flex items-center justify-center min-w-[1.25rem] rounded-full bg-black/10 px-1 text-[10px] tabular-nums leading-4">
                                    {option.count}
                                </span>
                            ) : null}
                        </span>
                    </SecondaryCompactButton>
                );
            })}
        </div>
    );
};
